// Copied from @passkeys/ui/skeleton due to colors being significantly different.
// TODO: Unify back once colors are solved.

const WIDTH = 80;
const HEIGHT = 18;

function FancyAmountSkeleton() {
  return (
    <div
      className="flex-1 animate-pulse bg-[--collapsed-skeleton-color,theme(colors.gray.200)]"
      style={{
        width: `${WIDTH}px`,
        height: `${HEIGHT}px`,
        borderRadius: `${HEIGHT / 4}px`,
      }}
    />
  );
}

export default FancyAmountSkeleton;
